import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import React, { Component } from "react";
import "scss/screens/setting/companyDetail.scss";
import { Form, Icon } from "semantic-ui-react";

export default class CompanyDetail extends Component {
  render() {
    return (
      <div className="companyDetail">
        <Navigation />
        <Sidebar tabActive="setting" setting="company" />

        <div className="companyDetail-content">
          <h2>การตั้งค่า</h2>
          <hr />

          <div className="companyDetail-content-detail">
            <div className="company">
              <div className="company-header">
                <h3>
                  <Icon name="building" />
                  ข้อมูลกิจการ
                </h3>
                <hr />
              </div>

              <div className="company-image">
                <img
                  src={require("../../assets/CLP_LOGO.png")}
                  alt="company_image"
                  width={200}
                />
              </div>

              <div className="company-detail">
                <table>
                  <tbody>
                    <tr>
                      <td>ชื่อกิจการ</td>
                      <td>
                        <Form>
                          <Form.Input
                            value={
                              "บริษัท ซีแอลพี อินเตอร์เทรด จำกัด (สำนักงานใหญ่)"
                            }
                            readOnly
                          />
                        </Form>
                      </td>
                    </tr>
                    <tr>
                      <td>โทรศัพท์</td>
                      <td>
                        <Form>
                          <Form.Input value={"+66-2-286-6098-9"} readOnly />
                        </Form>
                      </td>
                    </tr>
                    <tr>
                      <td>อีเมล</td>
                      <td>
                        <Form>
                          <Form.Input value={"sales@clpbrand.com"} readOnly />
                        </Form>
                      </td>
                    </tr>
                    <tr>
                      <td>ที่อยู่</td>
                      <td>
                        <Form>
                          <Form.TextArea
                            type="text"
                            value={`ที่อยู่หลัก (สำนักงานใหญ่)
                                    ชั้น 2 อาคารโชว์รูมนิสสัน โยโกตะ (สถานี BRT ถนนจันทร์) เลขที่ 5 ถนนนราธิวาสราชนครินทร์ แขวงช่องนนทรี เขตยานนาวา กรุงเทพฯ 10120 กรุงเทพมหานคร ไทย`}
                          ></Form.TextArea>
                        </Form>
                      </td>
                    </tr>
                    <tr>
                      <td>เลขประจำตัวผู้เสียภาษี </td>
                      <td>
                        <Form>
                          <Form.Input value={"0135556010284"} readOnly />
                        </Form>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
